



































import {Component, Vue} from 'vue-property-decorator'


@Component({
  components: {},
})
export default class DatePicker extends Vue {

  open: boolean = false
  date = ''

  onApply: Function = () => {
  }

  created() {
    this.$root.$on('openDatePicker', this.onOpen)
  }

  onOpen({date, onApply}) {
    if (this.open) return
    console.log('Emited', {date})
    this.date = date

    this.open = true

    this.onApply = onApply
  }

};

